import { useQuery } from '@tanstack/react-query'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { isUserAdminInSociety } from '../../../helpers/society'
import { useAuthenticatedUserId } from '../../../hooks/useAuthenticatedUserId'
import { societyGuidesQueries } from '../../../api/society-guides'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useShowGettingStarted = () => {
  const { society } = useCurrentSociety()
  const authUserId = useAuthenticatedUserId()
  const currentUserIsAdmin = isUserAdminInSociety(society, authUserId as string)
  const { data: getToKnow } = useQuery(
    societyGuidesQueries.getToKnow(society?._id, currentUserIsAdmin)
  )
  const { data: gettingStarted } = useQuery(
    societyGuidesQueries.gettingStarted(society?._id, currentUserIsAdmin)
  )

  const shouldShowGetToKnow = (): boolean => {
    if (!currentUserIsAdmin) {
      return false
    }
    if (getToKnow?.completed) {
      return false
    }
    if (getToKnow?.started) {
      return true
    }
    return false
  }
  const shouldShowGettingStarted = (): boolean => {
    if (!currentUserIsAdmin) {
      return false
    }
    if (!getToKnow?.completed) {
      return false
    }
    if (gettingStarted?.completed) {
      return false
    }
    if (gettingStarted?.started) {
      return true
    }
    return false
  }
  return {
    showGettingStarted: shouldShowGettingStarted(),
    showGetToKnow: shouldShowGetToKnow(),
    society,
  }
}

export default useShowGettingStarted
